<template>
  <card-info>
    <div class="content">
      <card-header card="product"></card-header>
      <tabs :tabs="tabs" :active="activeTab" @setTab="setTab" />
      <info v-if="activeTab === 0 && id" :id="id" />
      <images v-if="activeTab === 1 && id" :id="id" />
      <features v-if="activeTab === 2 && id" :id="id" />
      <product v-if="activeTab === 3 && id" :id="id" />
      <seo
            v-if="activeTab === 4 && id"
            metatable_type="option"
            :metatable_id="id"
      />
      <!-- <serials v-if="activeTab === 5 && id" :id="id" /> -->
      <compare v-if="activeTab === 5 && id" :id="id" />
    </div>
  </card-info>
</template>
<script>
import CardHeader from "../CardHeader";

import Tabs from "../../Tabs";

export default {
  name: "label",
  props: ["id"],
  components: {
    CardHeader,
    Tabs,
    info: () => import("./Info"),
    images: () => import("./Images"),
    features: () => import("./Features"),
    serials: () => import("./Serials"),
    seo: () => import("../Seo"),
    product: () => import("./Product"),
    compare: () => import("./Compare"),
  },
  data() {
    return {
      loading: true,
      tabs: [
        {
          title: "Модификация",
        },
        {
          title: "Изображения",
        },
        {
          title: "Характеристики",
        },
        {
          title: "Группа",
        },
          {
          title: "SEO оптимизация",
        },
        //   {
        //   title: "Серийники",
        // },
          {
          title: "Сравнение",
        },
      ],
      activeTab: 0,
    };
  },
  methods: {
    setTab(val) {
      this.activeTab = val;
    },
    
  },
  created() {},
};
</script>